import React, {useEffect, useContext, useState} from 'react';
import Login from '../login/Login';
import './checkout.css'
import Order from './Order';
import { UserContext } from '../../context/UserProvider';
import {useCartContext} from '../../context/cartContext'

//muestra el comienzo de finalizar la compra
function Checkout ({show, isDisabled, onNameChange, message, onSubmit, status, orderId}){
  const [cambio, setCambio] = useState(false)
  const {clearItems, total, getUnits} = useCartContext();
  const {user,inicioS} = useContext(UserContext)

    useEffect(() => {
     
      if(user){
        setCambio(true)
      }
    }, [inicioS,user,cambio])
    return(  
      <>  
          <div className="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">ULTIMO PASO...!</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                
                <div className="modal-body">
                  {!inicioS ? <>
                  <li>Cantidad de productos: {getUnits()}</li> 
                 <li>Total Pedido: ${total()}</li>
                  <div className="form">
                    <div className="form-group col-md-6">
                      <label  className="">Nombre y Apellido</label>
                      <input type="text" className="mb-2" name="nombre" onChange={onNameChange} required/>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Email</label>
                      <input type="text" name="email" onChange={onNameChange} required/>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Reingrese su Email</label>
                      <input type="text" name="email2" onChange={onNameChange}  required/>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Telefono</label>
                      <input type="number" name="telefono" onChange={onNameChange} required/>
                    </div>
                    {message && <p className="email-err">{message}</p>}
                  </div>
                  <hr></hr>
                  <Login/></> : <p> Confirme su compra {cambio && user.displayName}</p>}
                </div> 
                  
                  
                <div className="modal-footer">
                  <button type="button" className="btn cart" data-dismiss="modal">Cancelar</button>
                  <button type="button" className="btn cart" data-toggle="modal" data-target="#Order" data-dismiss="modal" disabled={isDisabled()} onClick={()=>onSubmit()}>Confirmar Compra</button> 
                </div>
              </div>
            </div>
          </div>
          <Order show={show} status={status} orderId={orderId} clearItems={clearItems} message={message}/>
        </>
    )

}

export default Checkout;